<div #parentDiv class="border rounded-xl shadow-lg px-1 py-1 h-[200px] md:h-[400px] relative">
  <canvas #canvas></canvas>
  <button type="button" (click)="clearPad()" class="absolute bottom-2 md:bottom-5 right-2 md:right-5" title="Chỉnh sửa chữ ký">
    <img src="./assets/icons/icon-edit.svg" alt="edit icon" class="" />
  </button>
</div>